import firebase from '../firebase';
import { loadStripe } from '@stripe/stripe-js';

export const handlePaymentClick = async (user, priceId, trialConsume) => {
        const dbFirestore = firebase.firestore();
    
    let trialDays = 0;


    if (trialConsume !== "true") {
        if (
            priceId === process.env.REACT_APP_B_MONTHLY ||
            priceId === process.env.REACT_APP_BASIC_MONTHLY ||
            priceId === process.env.REACT_APP_PRO_MONTHLY ||
            priceId === process.env.REACT_APP_BASIC_MONTHLY_THREE ||
            priceId === process.env.REACT_APP_SOLO_MONTHLY_THREE ||
            priceId === process.env.REACT_APP_PRO_MONTHLY_THREE ||
            priceId === process.env.REACT_APP_BASIC_MONTHLY_FIVE ||
            priceId === process.env.REACT_APP_SOLO_MONTHLY_FIVE ||
            priceId === process.env.REACT_APP_PRO_MONTHLY_FIVE ||
            priceId === process.env.REACT_APP_BASIC_MONTHLY_FOUR ||
            priceId === process.env.REACT_APP_SOLO_MONTHLY_FOUR ||
            priceId === process.env.REACT_APP_PRO_MONTHLY_FOUR ||
            priceId === process.env.REACT_APP_BASIC_MONTHLY_TWO ||
            priceId === process.env.REACT_APP_SOLO_MONTHLY_TWO ||
            priceId === process.env.REACT_APP_PRO_MONTHLY_TWO
        ) {
            trialDays = 7;
        } else if (
            priceId === process.env.REACT_APP_B_YEARLY ||
            priceId === process.env.REACT_APP_BASIC_YEARLY ||
            priceId === process.env.REACT_APP_PRO_YEARLY ||
            priceId === process.env.REACT_APP_BASIC_YEARLY_THREE||
            priceId === process.env.REACT_APP_SOLO_YEARLY_THREE||
            priceId === process.env.REACT_APP_PRO_YEARLY_THREE ||
            priceId === process.env.REACT_APP_BASIC_YEARLY_FIVE||
            priceId === process.env.REACT_APP_SOLO_YEARLY_FIVE||
            priceId === process.env.REACT_APP_PRO_YEARLY_FIVE ||
            priceId === process.env.REACT_APP_BASIC_YEARLY_FOUR||
            priceId === process.env.REACT_APP_SOLO_YEARLY_FOUR||
            priceId === process.env.REACT_APP_PRO_YEARLY_FOUR ||
            priceId === process.env.REACT_APP_BASIC_YEARLY_TWO||
            priceId === process.env.REACT_APP_SOLO_YEARLY_TWO||
            priceId === process.env.REACT_APP_PRO_YEARLY_TWO
        ) {
            trialDays = 15;
        }
    }

    const docRef = await dbFirestore.collection('user').doc(user.uid).collection("checkout_sessions").add({
        price: priceId,
        success_url: window.location.origin,
        cancel_url: window.location.origin,
        trial_period_days: trialDays,
        allow_promotion_codes: true,
    });

    docRef.onSnapshot(async (snap) => {
        const { error, sessionId } = snap.data();
        if (error) {
            alert(error.message);
        }
        if (sessionId) {
            const stripe = await loadStripe(process.env.REACT_APP_STRIPE_KEY);
            stripe.redirectToCheckout({ sessionId });
        }
    });
};